import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { rgba } from "polished";
import { Box } from "rebass";

const ImageContainer = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.75;
  background: transparent;
  mix-blend-mode: screen;

  &:after {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.2);
  }
`;

const Image = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  mix-blend-mode: multiply;
  filter: grayscale(1) contrast(1.3);
  opacity: 0.9;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;

  /* Fallback */
  background-image: ${(props) =>
    "url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")"};

  /* Webkit fallback */
  background-image: ${(props) =>
    "-webkit-image-set(url(" +
    (props.backgroundImage ? props.backgroundImage[2] : "") +
    ") 1x, url(" +
    (props.backgroundImage ? props.backgroundImage[1] : "") +
    ") 2x)"};

  /* Regular imageset */
  background-image: ${(props) =>
    "image-set(url(" +
    (props.backgroundImage ? props.backgroundImage[2] : "") +
    ") 1x, url(" +
    (props.backgroundImage ? props.backgroundImage[1] : "") +
    ") 2x)"};

  @media (min-width: 52em) {
    /* Fallback */
    background-image: ${(props) =>
      "url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ")"};

    /* Webkit fallback */
    background-image: ${(props) =>
      "-webkit-image-set(url(" +
      (props.backgroundImage ? props.backgroundImage[1] : "") +
      ") 1x, url(" +
      (props.backgroundImage ? props.backgroundImage[1] : "") +
      ") 2x, url(" +
      (props.backgroundImage ? props.backgroundImage[0] : "") +
      ") 3x)"};

    /* Regular imageset */
    background-image: ${(props) =>
      "image-set(url(" +
      (props.backgroundImage ? props.backgroundImage[1] : "") +
      ") 1x, url(" +
      (props.backgroundImage ? props.backgroundImage[1] : "") +
      ") 2x, url(" +
      (props.backgroundImage ? props.backgroundImage[0] : "") +
      ") 3x)"};
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    background-image: ${(props) =>
      props.theme.colors[props.imageColor] &&
      "linear-gradient(to bottom, " +
        (props.imageColor
          ? rgba(props.theme.colors[props.imageColor], 0.66)
          : "") +
        ", " +
        (props.imageColor
          ? rgba(props.theme.colors[props.imageColor], 0.66)
          : "") +
        "), url(" +
        (props.backgroundImage ? props.backgroundImage[2] : "") +
        ")"};
  }
`;

const OverlayImage = (props) => (
  <ImageContainer>
    <Image
      imageColor={props.imageColor}
      backgroundImage={props.backgroundImage}
    />
  </ImageContainer>
);

OverlayImage.defaultProps = {};

export default OverlayImage;



// WEBPACK FOOTER //
// ./src/components/OverlayImage.js